
import { mapGetters } from 'vuex';
import AdsApi from '../../libs/ads-request/ads-api';

export default {
  name: 'NotAuthorized',
  props: {
    activities: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    notInterested: null,
    reminder: null,
    orderWork: {},
    activitiesInPackage: [],
    notInterestedOptions: [
      { label: 'Necesito más información', value: 1 },
      { label: 'No me interesa', value: 2 },
      { label: 'Otra razón', value: 3 },
    ],
    reminderOptions: [
      { label: 'Sí, deseo que me recuerden', value: 1 },
      { label: 'No, no deseo que me recuerden', value: 0 },
    ],
  }),
  computed: {
    ...mapGetters('Quotation', {
      rejectedActivities: 'getRejectedActivities',
    }),
    disabledSubmitButton() {
      return this.notInterested != null && this.reminder != null;
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
    isThemeAudi() {
      return this.$session.get('brand') === 'audi';
    },
    isThemeSeat() {
      return this.$session.get('brand') === 'seat';
    },
    isThemeVolkswagen() {
      return this.$session.get('brand') === 'volkswagen';
    },
  },
  methods: {
    acceptBudget() {
      this.$emit('acceptBudget');
    },
    sendResponse() {
      this.loaderShow('Guardando respuestas');

      AdsApi.saveCustomerRejection(
        this.activities[0].order_activity_id,
        this.notInterested,
        this.reminder,
      )
        .then((res) => {
          const response = res.data;
          if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);
          this.disabled = true;
          this.loaderHide();
          this.acceptBudget();
        })
        .catch((error) => {
          this.loaderHide();
          this.alertShow(error, 'error');
        });
    },
  },
};
